import { FormInputBase } from './form-input-base';

export class ChipsTextbox extends FormInputBase<string> {
  override controlType = 'chipsbox';
}
